module.exports = __webpack_public_path__ + "static/media/img-5.e3a331e7.jpg";